import { FC, useEffect, useState } from "react";
import { Button, Input, message, DatePicker, Form, Space, Select } from "antd";
import { useNavigate } from "react-router-dom";
import Card from "antd/es/card/Card";
import { UserSave } from '../../shared/types/request/saveUser.model'
import { useSaveUser } from "../../shared/services/utilisateurs/user.service";
import dayjs from 'dayjs';

const CreationPage: FC = () => {

    const navigate = useNavigate()

    function retourVersConnexion() {
        navigate("/connexion")
    }

    const[formValues, setFormValues] = useState<UserSave | null>();

    const onFinish = (values: any) => {
        const userDateFormat: UserSave = {
            ...values,
            naissance: (values.naissance as dayjs.Dayjs).format("DD/MM/YYYY"),
            telephone: `${values.prefixeTelephone}${values.telephone}`
        };
        setFormValues(userDateFormat);
    };

    const {data, isLoading, error} = useSaveUser(formValues);

    const[messageApi, contextHolder] = message.useMessage();

    useEffect(() =>{
        if(error && error.response.data.erreur){
            messageApi.error(error.response.data.erreur);
        }else{
            if(error)
            {
                messageApi.error(error.message);
            }
        }
    }, [error])

    useEffect(() => {
        if(data && data.ok){
            messageApi.success(data.ok);
            navigate("/connexion")
        }
    }, [data])

    const dateFormat = 'DD/MM/YYYY';

    const prefixeTelephone = [
        {
            value: "+33",
            label: "+33"
        },
        {
            value: "+32",
            label: "+32"
        }
    ]

    return (
        <Card title={<span style={{ textAlign: "center" }}>Création de compte</span>} variant="borderless" className="responsive-card">
            {contextHolder}
            <div style={{paddingLeft:"5%", paddingRight:"30%"}}>
                <Form layout="vertical" onFinish={onFinish} initialValues={{prefixeTelephone: "+33"}}>

                    <Form.Item
                        label="Nom d'utilisateur"
                        name="username"
                        rules={[{required: true, message: "Nom requis"}]}
                    >
                        <Input placeholder="Nom d'utilisateur" />
                    </Form.Item>


                    <Form.Item
                        label="Mot de passe"
                        name="password"
                        rules={[
                            {required: true, message: "Mot de passe requis"},
                            {min: 6, message: "Minimum 6 caractères"}
                        ]}
                        hasFeedback
                    >
                        <Input.Password placeholder="Mot de passe" />
                    </Form.Item>


                    <Form.Item
                        label="Confirmer le mot de passe"
                        name="confirmPassword"
                        dependencies={["password"]}
                        hasFeedback
                        rules={[
                            {required: true, message: "Confirmez le mot de passe"},
                            ({getFieldValue}) => ({
                                validator(_, value){
                                    if(!value || getFieldValue("password") === value){
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(
                                        new Error("Les mots de passe ne correspondent pas")
                                    )
                                }
                            })
                        ]}
                    >
                        <Input.Password placeholder="Confirmer le mot de passe" />
                    </Form.Item>


                    <Form.Item
                        label="Nom"
                        name="nom"
                        rules={[{required: true, message: "Nom requis"}]}
                    >
                        <Input placeholder="Nom" />
                    </Form.Item>


                    <Form.Item
                        label="Prénom"
                        name="prenom"
                        rules={[{required: true, message: "Prénom requis"}]}
                    >
                        <Input placeholder="Prénom" />
                    </Form.Item>


                    <Form.Item
                        label="Date de naissance"
                        name="naissance"
                        rules={[{required: true, message: "Date de naissance requis"}]}
                    >
                        <DatePicker required placeholder="DD/MM/YYYY" format={dateFormat} />
                    </Form.Item>

                    <Form.Item label="Numéro de téléphone" required >
                        <Space.Compact>
                            <Form.Item
                                name="prefixeTelephone"
                                noStyle
                            >
                                <Select style={{width:"80px"}} placeholder="+33" options={prefixeTelephone} />
                            </Form.Item>
                            <Form.Item
                                name="telephone"
                                noStyle
                                rules={[
                                    {required: true, message: "Numéro de téléphone requis"},
                                    {
                                        pattern: /^\d{9}$/,
                                        message: "Numéro invalide. 9 chiffres attendus"
                                    }
                                ]}
                            >
                                <Input placeholder="6XXXXXXXX" maxLength={9} />
                            </Form.Item>
                        </Space.Compact>
                    </Form.Item>

                    <Form.Item
                        label="Adresse mail"
                        name="mail"
                        rules={[
                            {required: true, message: "Adresse mail requis"},
                            { type:"email", message: "Email invalide"}
                        ]}
                    >
                        <Input placeholder="Adresse mail" />
                    </Form.Item>


                    <Form.Item
                        label="Numéro de la voie"
                        name="numVoie"
                        rules={[{required: true, message: "Numéro de la voie requis"},
                            {
                                pattern: /^[0-9]+$/,
                                message: "Le numéro de voie n'est composé que de chiffres"
                            }
                        ]}
                    >
                        <Input placeholder="Numéro de voie" />
                    </Form.Item>


                    <Form.Item
                        label="Nom de la voie"
                        name="nomVoie"
                        rules={[{required: true, message: "Nom de la voie requis"}]}
                    >
                        <Input placeholder="Nom de voie" />
                    </Form.Item>


                    <Form.Item
                        label="Code Postal"
                        name="codePostal"
                        rules={[
                            {required: true, message: "Code postal requis"},
                            {
                                pattern: /^[0-9]{4,5}$/,
                                message: "Le code postal doit contenir entre 4 ou 5 chiffres"
                            }
                        ]}
                    >
                        <Input placeholder="Code postal" />
                    </Form.Item>


                    <Form.Item
                        label="Ville"
                        name="ville"
                        rules={[{required: true, message: "Nom de la ville requis"}]}
                    >
                        <Input placeholder="Ville" />
                    </Form.Item>
                    <Button type="primary" loading={isLoading} htmlType="submit">
                        Sauvegarder
                    </Button>
                </Form>
                <Button onClick={retourVersConnexion} loading={isLoading} style={{ marginTop: "24px" }}>Retour</Button>
            </div>
            
        </Card>
    )
}

export default CreationPage;